<template>
  <app-page>
    <div class="about">
      <ul class="about-list">
        <li class="about-list-item" v-for="(value,index) in list" :key="index" @click="goRouter(value)">
          <div class="description">
          <span class="icon">
            <img :src="value.icon" alt="">
          </span>
            <div class="title">
              <h2>{{value.title}}</h2>
              <p>{{value.description}}</p>
            </div>
          </div>
          <span class="icon">
          <img src="@/assets/svg/about/ic_enter.svg" alt="">
        </span>
        </li>
      </ul>
    </div>
  </app-page>
</template>

<script>
    import AppPage from '../layouts/Main';
    import icon1 from '@/assets/svg/about/index_list_item_icon_1-new.png';
    import icon2 from '@/assets/svg/about/index_list_item_icon_2.svg';
    import icon3 from '@/assets/svg/about/index_list_item_icon_3.svg';
    import icon4 from '@/assets/svg/about/index_list_item_icon_4.svg';
    import icon5 from '@/assets/svg/about/index_list_item_icon_5.svg';
    import icon6 from '@/assets/svg/about/index_list_item_icon_6.svg';
    import icon7 from '@/assets/svg/about/index_list_item_icon_7.svg';
    import icon8 from '@/assets/svg/about/index_list_item_icon_8.svg';
    import icon9 from '@/assets/svg/about/index_list_item_icon_9.svg';
    import icon10 from '@/assets/svg/about/index_list_item_icon_10.svg';
    export default {
        name: 'about',
        components: {
          AppPage
        },
        data() {
            return {
                list:[
                  {
                    icon:icon1,
                    title:'关于我们',
                    description:'了解翡翠王朝公司',
                    router: 'about.us',
                    path: "about/us",
                  },
                  {
                    icon:icon2,
                    title:'分公司介绍',
                    description:'更加了解各公司风采',
                    router:'about.company',
                    path:"about/company"
                  },
                  {
                    icon:icon3,
                    title:'公益事业',
                    description:'致力于传播玉石文化，弘扬玉雕艺术',
                    router:'about.commonweal',
                    path:"about/commonweal"
                  },
                  {
                    icon:icon4,
                    title:'专家委员会',
                    description:'致力于传播玉石文化，弘扬玉雕艺术',
                    router:'about/expert',
                    path:"about/expert"
                  },
                  {
                    icon:icon5,
                    title:'售后服务',
                    description:'更多退货相关内容等你了解',
                    router:'about.aftersale',
                    path: "about/aftersale"
                  },
                  {
                    icon:icon6,
                    title:'品质保障',
                    description:'7天退换、假一赔十、源头供货、保价邮寄',
                    router:'about.ensure',
                    path: "about/ensure"
                  },
                  {
                    icon:icon10,
                    title:'保真承诺',
                    description:'国家认定资质权威检测机构证书',
                    router:'about/promise',
                    path:"about/promise?courseShow=0"
                  },
                  {
                    icon:icon7,
                    title:'如何购买',
                    description:'快速了解购买方式',
                    router:'about.purchase',
                    path: "about/purchase",
                  },
                  {
                    icon:icon8,
                    title:'关注我们',
                    description:'有任何问题可以留言给我们',
                    router:'about.follow',
                    path: "about/follow"
                  },
                  {
                    icon:icon9,
                    title:'联系我们',
                    description:'有任何问题联系我们',
                    router:'about.contact',
                    path: "about/contact"
                  }

                ],
            }
        },
        computed: {
        },
        mounted() {},
        methods:{
          goRouter(value){
            const { path = '', title = ''} =  value || {}
            this.$JD.router({
              path,
              url:this.$JD.apph5_page(path),
              title:title,
            });
          }
        }
    }
</script>

<style lang="scss" >
body{
  background-color: rgba(255,255,255,1);
}
.about{
  height: 100%;
  background-color: rgba(255,255,255,1);
}
.about-list{
  padding: 0 0.2rem;
}
.about-list-item{
  padding: 0.2rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(240, 240, 244, 1);
  .description{
    display: flex;
    align-items: center;
    text-align: left;
    .icon{
      width: 0.48rem;
      height: 0.49rem;
      margin-right: 0.13rem;
    }
    .title{
      h2{
        font-size:0.2rem;
        color:rgba(29,29,29,1);
      }
      p{
        font-size:0.1733rem;
        color:rgba(114,114,114,1);
      }
    }

  }
  .icon{
    display: flex;
    height: 0.21rem;
    width: 0.21rem;
  }
}
.about-list-item:last-child{
  border: none;
}
</style>
